module.exports = __webpack_public_path__ + "images/c47c8b3afae7a37ace4919bf4c8ea1b7b979d9c5383d32f26b2a26337293797b.svg";